// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"160":"jquery-colorbox","390":"swiper","766":"adventuresArchiveTemplate"}[chunkId] || chunkId) + ".bundle.js";
};